'use client'
import { defineSlotRecipe } from '@chakra-ui/react'
import { drawerAnatomy } from '@chakra-ui/react/anatomy'

export const drawerSlotRecipe = defineSlotRecipe({
    slots: drawerAnatomy.keys(),
    variants: {
        size: {
            xl: {
                content: {
                    maxWidth: 'var(--chakra-sizes-8xl);',
                },
            },
        },
    },
})
